/**
 * Removes the 'memid' query parameter from a given URLSearchParams object.
 * @param params - The URLSearchParams object to modify.
 * @returns A new URLSearchParams object without the 'memid' parameter.
 */
export const removeMemIdParam = (params: URLSearchParams): URLSearchParams => {
    const updatedParams = new URLSearchParams(params.toString());
    updatedParams.delete('memid');
    return updatedParams;
};

